// ADR-0163 (#0770) — la tarjeta «Desde la consulta del propietario» del
// detalle de una observación que nació de una consulta: el enlace al hilo en
// la bandeja (`?consulta=<id>`) y las fotos que el jefe eligió al convertir,
// firmadas con la ruta del personal. Sólo llega `sourceInquiry` a los roles
// que leen la bandeja; el contratista nunca ve estas fotos.

import { Link } from "react-router-dom";
import { CONSULTA_DEL_PROPIETARIO } from "@bitacorapro/api-types";
import { useOwnerInquiryAttachmentUrls } from "../lib/api/queries";

export function DesdeLaConsulta({
  assetGroupId,
  inquiryId,
  attachmentIds,
}: {
  assetGroupId: string;
  inquiryId: string;
  attachmentIds: readonly string[];
}) {
  const urls = useOwnerInquiryAttachmentUrls(inquiryId, attachmentIds);
  return (
    <section aria-labelledby="obs-desde-consulta">
      <div className="drawer__section-label" id="obs-desde-consulta">
        Desde la {CONSULTA_DEL_PROPIETARIO.toLocaleLowerCase("es-CL")}
      </div>
      <p className="cell-sub">
        Nació de una consulta del propietario. Sus fotos las ven sólo el equipo y el propietario.{" "}
        <Link to={`/proyectos/${assetGroupId}/consultas?consulta=${inquiryId}`}>
          Ver la consulta
        </Link>
      </p>
      {attachmentIds.length > 0 && (
        <div className="evc__thumbs">
          {attachmentIds.map((id, i) => {
            const url = urls.data?.get(id);
            return (
              <span key={id} className="evc__thumb" aria-label={`Foto ${i + 1} de la consulta`}>
                {url && <img src={url} alt="" />}
              </span>
            );
          })}
        </div>
      )}
      {urls.isError && (
        <p className="auth-error" role="alert">
          No pudimos cargar las fotos de la consulta.
        </p>
      )}
    </section>
  );
}
